import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * Exibe children apenas se o usuário tiver permissão.
 *
 * @param {object} props
 * @param {string} [props.permission] — uma permissão (ex.: P.USERS_MANAGE)
 * @param {string[]} [props.any] — basta uma das permissões
 * @param {string[]} [props.all] — exige todas
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode} [props.fallback] — opcional quando negado (default: null)
 */
const Can = ({ permission, any: anyOf, all: allOf, children, fallback = null }) => {
  const { hasPermission } = usePermissions();

  let allowed = false;
  if (Array.isArray(allOf) && allOf.length > 0) {
    allowed = allOf.every((p) => hasPermission(p));
  } else if (Array.isArray(anyOf) && anyOf.length > 0) {
    allowed = anyOf.some((p) => hasPermission(p));
  } else if (permission) {
    allowed = hasPermission(permission);
  } else {
    allowed = true;
  }

  if (!allowed) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default Can;
